








import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class MdcTopAppBarActionItem extends Vue{

  @Prop({type:Boolean,default:false}) alignStart!:boolean

  @Prop({type:Boolean,default:false}) alignEnd!:boolean

  @Prop({default:undefined}) to?:string
}
